import {
    deleteRequest,
    putRequest,
    getRequest,
    postRequest,
 } from "../../utils/api";
 export const apiListConsumeList = (page,size,data) => {
   return postRequest('/api/vipCard/consume/list?page='+page+'&size='+size, data)
}

 
 